module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15ymV5J/tc-custom/9780830848171.jpg?1696374747118",
      "alt": "This image is the cover for the book Talking Back to Purity Culture"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Talking Back to Purity Culture\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('strong', [_vm._v("It's time to talk back.")])]), _vm._v(" "), _c('p', [_vm._v("The generation born into evangelical purity culture has grown up, and many have started families of their own. But as time goes on, it's becoming more evident that many still struggle with purity culture's complicated legacy—its idolization of virginity, its mixed messages about modesty and lust, and its promise of a healthy marriage and great sex for those who follow the rules.")]), _vm._v(" "), _c('p', [_vm._v("In "), _c('em', [_vm._v("Talking Back to Purity Culture")]), _vm._v(", Rachel Joy Welcher reviews the movement carefully, examining its teachings through the lens of Scripture. Compassionate, faithful, and wise, she charts a path forward for Christians in the ongoing debates about sexuality—one that rejects legalism and license alike, steering us back instead to the good news of Jesus.")]), _vm._v(" "), _c('p', [_vm._v("It's time to talk back to purity culture—and this book is ready to jump-start the conversation.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rachel Joy Welcher, Scott Sauls\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Rachel Joy Welcher (MLit, University of St. Andrews) is a columnist and editor at "), _c('em', [_vm._v("Fathom")]), _vm._v("magazine. She is the author of two books of poetry: "), _c('em', [_vm._v("Blue Tarp")]), _vm._v(" and "), _c('em', [_vm._v("Two Funerals, Then Easter")]), _vm._v(". She lives in Glenwood, Iowa, with her husband, Evan.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0